import { render, staticRenderFns } from "./ContentSidebarStock.vue?vue&type=template&id=b38373a0&"
import script from "./ContentSidebarStock.vue?vue&type=script&lang=js&"
export * from "./ContentSidebarStock.vue?vue&type=script&lang=js&"
import style0 from "./ContentSidebarStock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports